import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from '../api/axios';
import { Apitoken, Authtoken } from '../Global';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

const EditTransportModel = ({ itemId, handleClose, show }) => {
  // const [showCategory, setShowCategory] = useState(false);
  const [formData, setFormData] = useState({});
  const [backendSuccess, setBackendSuccess] = useState(null);
  const [backendErrors, setBackendErrors] = useState([]);
  console.log("Modal show prop add:", show);

  useEffect(() => {
      

    if (itemId) {
      axios
        .get(`/rawmaterials-transports/edit/${itemId}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            setFormData(response.data.data.transport);
          }
        })
        .catch((error) => console.log(error));
    }
  }, [itemId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    delete backendErrors[name];
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post('/rawmaterials-transports/update', formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setBackendSuccess(response.data.message);
          toast.success(response.data.message);
          setTimeout(() => {
            window.location.href = '/rawmaterials-transports';
          }, 500);
        } else {
          setBackendErrors(response.data.error);
        }
      })
      .catch((error) => console.log(error));
  };

  return (
    <Modal centered show={show} onHide={handleClose}>
      <Modal.Header>
        <h4 className="modal-title">Edit Transport</h4>
        <button type="button" className="close" onClick={handleClose} aria-hidden="true">
          &times;
        </button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          {backendSuccess && <div className="from-success mt-1">{backendSuccess}</div>}

          <div className="form-group">
            <label>Driver Name</label>
            <input
              className="form-control form-white"
              placeholder=" driver_name"
              type="text"
              name="driver_name"
              value={formData.driver_name || ''}
              onChange={handleChange}
            />
            {backendErrors.driver_name && <small className="form-error mt-1">{backendErrors.driver_name}</small>}
          </div>

          <div className="form-group">
            <label>Phone Number</label>
            <input
              className="form-control form-white"
              placeholder="Phone Number"
              type="text"
              name="phone_number"
              value={formData.phone_number || ''}
              onChange={handleChange}
            />
            {backendErrors.phone_number && (
              <small className="form-error mt-1">{backendErrors.phone_number}</small>
            )}
          </div>
          <div className="form-group">
              <label>Plate Number</label>
              <input
                className="form-control form-white"
                placeholder="Plate Number"
                type="text"
                name="plate_number"
                value={formData.plate_number}
                onChange={handleChange}
              />
              {backendErrors.plate_number && (
                <small className="form-error mt-1">
                  {backendErrors.plate_number}
                </small>
              )}
            </div>
         

          <div className="form-group">
            <label>Note:</label>
            <textarea
              className="form-control form-white"
              placeholder="Enter Note"
              name="note"
              value={formData.note || ''}
              onChange={handleChange}
            ></textarea>
            {backendErrors.note && <small className="form-error mt-1">{backendErrors.note}</small>}
          </div>

          <div className="submit-section">
            <button type="submit" className="btn btn-primary save-category submit-btn">
              UPDATE
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

EditTransportModel.propTypes = {
  itemId: PropTypes.number.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default EditTransportModel;
